module.exports = __webpack_public_path__ + "files/ea8e5c8684b6759c14f5981ecaf391e3.svg";